// extracted by mini-css-extract-plugin
export var modal = "_c0-0";